package dairy.mynotes.updatenotes

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import dairy.mynotes.repository.NotesRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class UpdateNotesUiState(
    val noteId: String = "",
    val userId: String = "",
    val category: String = "",
    val content: String = "",
    val isLoading: Boolean = false,
    val isSaved: Boolean = false,
    val isDeleted: Boolean = false,
    val error: String? = null
)

class UpdateNotesViewModel : ViewModel() {
    private val notesRepository = NotesRepository()

    private val _uiState = MutableStateFlow(UpdateNotesUiState())
    val uiState: StateFlow<UpdateNotesUiState> = _uiState.asStateFlow()

    fun loadNote(noteId: String) {
        if (noteId.isEmpty()) return
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(isLoading = true, error = null)
            notesRepository.getNote(noteId).onSuccess { note ->
                if (note != null) {
                    _uiState.value = _uiState.value.copy(
                        isLoading = false,
                        noteId = note.id,
                        userId = note.userId,
                        category = note.category,
                        content = note.content
                    )
                } else {
                    _uiState.value = _uiState.value.copy(isLoading = false, error = "Note not found")
                }
            }.onFailure { e ->
                _uiState.value = _uiState.value.copy(isLoading = false, error = e.message)
            }
        }
    }

    fun onContentChange(content: String) {
        _uiState.value = _uiState.value.copy(content = content)
    }

    fun saveNote() {
        val state = _uiState.value
        if (state.content.isBlank()) {
            _uiState.value = state.copy(error = "Description cannot be empty")
            return
        }
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(isLoading = true, error = null)
            // Use updateNoteContent to only update the content field,
            // preserving userId and all other original fields in Firestore
            notesRepository.updateNoteContent(state.noteId, state.content, state.userId).onSuccess {
                _uiState.value = _uiState.value.copy(isLoading = false, isSaved = true)
            }.onFailure { e ->
                _uiState.value = _uiState.value.copy(isLoading = false, error = e.message)
            }
        }
    }

    fun deleteNote() {
        val noteId = _uiState.value.noteId
        if (noteId.isEmpty()) return
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(isLoading = true, error = null)
            notesRepository.deleteNote(noteId).onSuccess {
                _uiState.value = _uiState.value.copy(isLoading = false, isDeleted = true)
            }.onFailure { e ->
                _uiState.value = _uiState.value.copy(isLoading = false, error = e.message)
            }
        }
    }
}
